module.exports = __webpack_public_path__ + "media/images/prev-0edc57ccafb3ea81859786274edf7897.png";